































































import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class OurSkills extends Vue {
  images: string[] = ["backend", "db", "cloud", "frontend"];

  /**
   * Get images for Carousel
   */
  getImages() {
    return this.images;
  }
}
